import { render, staticRenderFns } from "./Active_move.vue?vue&type=template&id=4839c72c&scoped=true&"
import script from "./Active_move.vue?vue&type=script&lang=js&"
export * from "./Active_move.vue?vue&type=script&lang=js&"
import style0 from "./Active_move.vue?vue&type=style&index=0&id=4839c72c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4839c72c",
  null
  
)

export default component.exports